import React, { useCallback, useState } from "react";
import { CustomImageNew } from "./CustomImage.jsx";
import * as styles from "./ImageCarousel.module.scss";
import classnames from "classnames";
import { faChevronLeft, faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ImageCarousel(props) {
    const {
        currentImageIndex,
        setCurrentImageIndex,
        images,
        objectFit = "cover",
        aspectRatio,
        aspectRatioX = aspectRatio?.split(":")[0] || 1,
        aspectRatioY = aspectRatio?.split(":")[1] || 1,
        imageChildren,
    } = props;

    const [localCurrentImageIndex, setLocalCurrentImageIndex] = useState(currentImageIndex || 0);

    const indexToUse = setCurrentImageIndex ? currentImageIndex : localCurrentImageIndex;

    const setCurrentImageIndexFn = useCallback(
        (index) => {
            const actualIndex = index < 0 ? images?.length - 1 : index % images?.length;
            if (setCurrentImageIndex) {
                setCurrentImageIndex(actualIndex);
            } else {
                setLocalCurrentImageIndex(actualIndex);
            }
        },
        [setCurrentImageIndex, setLocalCurrentImageIndex, images],
    );

    const moreThanOneImage = images?.length > 1;

    return (
        <div
            className={styles["image-container-outer"]}
            style={{
                aspectRatio: `${aspectRatioX}/${aspectRatioY}`,
            }}
        >
            <div className={styles["image-container-inner"]}>
                <CustomImageNew fill style={{ objectFit: objectFit }} src={images[indexToUse]} alt="Product image" />
                {imageChildren}
                {moreThanOneImage && (
                    <>
                        <div className={classnames(styles["dropdown-icon"], styles["dropdown-icon-left"])} onClick={() => setCurrentImageIndexFn(indexToUse - 1)}>
                            <FontAwesomeIcon
                                icon={faChevronLeft}
                                size={"sm"}
                                style={{
                                    width: "14px",
                                    height: "14px",
                                }}
                            />
                        </div>
                        <div className={classnames(styles["dropdown-icon"], styles["dropdown-icon-right"])} onClick={() => setCurrentImageIndexFn(indexToUse + 1)}>
                            <FontAwesomeIcon
                                icon={faChevronRight}
                                size={"sm"}
                                style={{
                                    width: "14px",
                                    height: "14px",
                                }}
                            />
                        </div>
                    </>
                )}
            </div>
            {moreThanOneImage && (
                <div className={styles["buttons-wrapper"]}>
                    {images?.map((_, index) => {
                        return (
                            <button
                                key={index}
                                onClick={() => setCurrentImageIndexFn(index)}
                                className={classnames(styles["image-toggle-btn"], index === indexToUse && styles["image-toggle-btn-selected"])}
                            >
                                <div className={styles["image-toggle-btn-icon"]}></div>
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
